import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { TimeApiService } from 'cbc-shared-lib';
import { Sgke411aResponseSearchresultList } from 'sg-api';

@Component({
  selector: 'app-sgke410d-result',
  templateUrl: './sgke410d-result.component.html',
  styleUrl: './sgke410d-result.component.scss'
})
export class Sgke410dResultComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  /** 検索結果リスト */
  @Input() searchresultList: Array<Sgke411aResponseSearchresultList>;
  /** 承認ボタン押下イベント */
  @Output() onClickApprovalEvent = new EventEmitter();
  /** 出力ボタン押下イベント */
  @Output() onClickOutputEvent = new EventEmitter();

  /** ソート */
  @ViewChild('sort1', { static: true }) sort!: MatSort;
  /** ページネイター */
  @ViewChild('paginator1', { static: true }) paginator: MatPaginator;

  /** データソース */
  dataSource: MatTableDataSource<Sgke411aResponseSearchresultList>;
  /** 選択した行の情報 */
  selection = new SelectionModel<Sgke411aResponseSearchresultList>(true, []);

  /**  テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'select',
    'payCtrNo',
    'visitormei',
    'lossJudgmentdivisionAname',
    'apprvReqDate',
    'lossReasonAname',
    'heisenDate',
    'heisenReasonAname',
    'chargeClsfyAname',
    'lossMny',
    'inSumaddLeasefee',
    'dryrskAmt',
    'lossSumMny',
    'pressmanagementdivisionAname',
    'pressTantoAreaAname',
  ];

  /** 出力ボタン非活性フラグ */
  public isOutputBtnDisabled: boolean = true;
  /** 欠損予定ステータス */
  LOSSYOTEI_STS_CODE = '02';

  /**
   * コンストラクタ
   * @param {ChangeDetectorRef} cd
   * @param {TimeApiService} timeApiService
   * @param {Router} router
   * @memberof Sgke410dResultComponent
   */
  constructor(
    private cd: ChangeDetectorRef,
    public timeApiService: TimeApiService,
    private router: Router,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke410dResultComponent
   */
  ngOnInit(): void {
    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke411aResponseSearchresultList>(this.searchresultList);

    // 出力ボタン非活性フラグ更新
    this.updateOutputBtnState();
    this.cd.detectChanges();
  }

  /**
   * 画面描画後初回処理
   * @memberof Sgke410dResultComponent
   */
  ngAfterViewInit() {
    // 表データとソートを連携
    this.dataSource.sort ??= this.sort;
  }

  /**
   * 画面描画後処理
   * @memberof Sgke410dResultComponent
   */
  ngAfterViewChecked() {
    // 表データとページングを連携
    if (this.dataSource) {
      this.dataSource.paginator ??= this.paginator;
    }
  }

  /**
   * 終了処理
   *
   * @memberof Sgke410dResultComponent
   */
  ngOnDestroy(): void {
  }

  /**
   * 承認ボタン押下時処理
   * @memberof Sgke410dResultComponent
   */
  onClickApproval() {
    this.onClickApprovalEvent.emit(this.selection.selected);
  }

  /**
   * 出力ボタン押下時処理
   * @memberof Sgke410dResultComponent
   */
  onClickOutput() {
    // 画面表示していないデータを含めた全てのデータのうち、欠損予定ステータスコード＝'02'(欠損判定依頼)のデータを対象としてSGKE404Aリクエストを作成
    const filteredData = this.dataSource.data.filter((row) => row.lossyoteiStsCode === '02');
    this.onClickOutputEvent.emit(filteredData);
  }

  /**
   * 行ダブルクリック時処理
   * @param {Sgke411aResponseSearchresultList} row
   * @memberof Sgke410dResultComponent
   */
  onDblClickRow(row: Sgke411aResponseSearchresultList) {

    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;

    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = row.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '10';

    // anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く	
    window.open(`${url}${params}`, '_blank');

  }

  /**
   * 出力ボタン非活性フラグ更新
   * @private
   * @returns {void}
   * @memberof Sgke410dResultComponent
   */
  private updateOutputBtnState(): void {
    this.isOutputBtnDisabled = !this.dataSource.data.some(row =>
      row.lossyoteiStsCode == this.LOSSYOTEI_STS_CODE);
  }
}
